<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form class="form" @submit.prevent>
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title fs-3">{{ detail?.name }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>

          <div class="modal-body" style="max-height: 400px; overflow: auto;">
            <div class="d-flex fs-4 justify-content-between mb-5">
              <div class="col-5 text-muted">{{$t('projects.estates.project')}}</div>
              <div class="col-7 fw-bold">{{detail?.project[0]?.title}}</div>
            </div>
            <div class="d-flex fs-4 justify-content-between mb-5">
              <div class="col-5 text-muted">{{$t('projects.estates.name')}}</div>
              <div class="col-7 fw-bold">{{detail?.name}}</div>
            </div>
            <div class="d-flex fs-4 justify-content-between mb-5" v-for="char in detail?.caracteristics" :key="char.id">
              <div class="col-5 text-muted">{{char.caracteric}}</div>
              <div class="col-7 fw-bold">{{char.value}}</div>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" @click="closeModal" :id="id+'_close_btn'" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.close"></Button>
            <Button type="new" @click.stop="updateEstate" :id="id+'_edit_btn'" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.edit"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <UpdateEstate :id="'estate_update_in_detail_modal_'+detail?.id" :form="formDataUpdateEstate" :edit="true" @load="load"/>
</template>

<script setup>
  import {defineProps, watch, ref} from 'vue'
  import Button from "@/components/Button.vue"
  import UpdateEstate from "./CreateOrUpdateEstate.vue";

  const emits = defineEmits(['load'])

  const props = defineProps({
      id: {
        type: String,
        required: true
      },
      detail: {
        type: Object,
        default: {}
      },
  })

  const formDataUpdateEstate = ref({...props.detail, project_id: ''})

  watch(
    () => props.detail,
    (newVal) => {
      formDataUpdateEstate.value = { ...newVal, project_id: '' }
    },
    { deep: true }
  )

  function load(){
    emits('load')
  }

  function updateEstate() {
    closeModal()
    formDataUpdateEstate.value = { ...formDataUpdateEstate.value, project_id: '' }
    $('#estate_update_in_detail_modal_'+props.detail?.id).modal('toggle')
  }

  function closeModal(){
    $('#'+props.id).modal('toggle')
  }
</script>